import React from 'react';
import { IonButton } from '@ionic/react';

// Components
import { ModalComponent } from './../../../components';

export const ErrorModal = ({ 
     message,
     urlImage,
     title,
     subtitle,
     handleFinish,
     closeModal,
     textButton 
    }) => {

    return (

        <>
            <ModalComponent 
                message={ message }
                urlImage={ urlImage }
                title={ title }
                subtitle={ subtitle }
                closeModal={() => { closeModal(); }}> 

                <IonButton 
                        type="button" 
                        color="primary"
                        shape="round" 
                        size="undefined"
                        onClick={ handleFinish }>{textButton}</IonButton>

            </ModalComponent>
        </>
    );
}

export default ErrorModal;